import Vue from "vue"
import firebase from "firebase";

const state = {
	chatStatus: true,
	chatStart: "08:00", 
	chatEnd: "23:00",
	taskStatuses: ['backlog', 'to-do', 'doing', 'done'],
	colors: ["accent", "indigo", "red", "green", "red", "purple", "deep-orange", "teal", "grey"],
	methodologies: ['In Person', 'Online Session', 'Telephone', 'Questionnaire', 'Other'],
	statuses: ['Recruited', 'Complete', 'Confirmed', 'Incentive Paid', 'Hold', 'Cancelled'],
	chat: false
};

const actions = {
	fetchSetting( {commit}, reference ){
		return new Promise((resolve, reject) => {
			firebase.firestore().doc("settings/"+reference).get()
			.then(doc => {
				if( !doc.empty ){
					commit("SET_SETTING", {reference: reference, data: doc.data() });
					resolve(doc.data());
				}
				else{
					reject();
				}
			})
		}) 
    }
};

const mutations = {
	SET_SETTING( state, {reference, data } ){
		Vue.set( state, reference, data );
	}
};


export default {
  state,
  actions,
  mutations,
};

